var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"elevation-0 mr-2 ml-n2",attrs:{"fab":"","small":"","color":_vm.color},on:{"click":function($event){return _vm.goBack()}}},[_c('v-icon',[_vm._v("arrow_back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }